import { ConversationRole } from 'src/types';
import { PromptListItem } from '../PromptListItem';
import styles from './PromptList.module.scss';
import { useGetEditorThread } from 'src/hooks';

export const PromptList = () => {
  const { editorThread } = useGetEditorThread();
  const { messages = [] } = editorThread ?? {};

  return (
    <div className={styles.root}>
      {[...messages].reverse().map((message, index) => {
        return (
          <PromptListItem
            key={message.id || index}
            role={
              message.type === 'human'
                ? ConversationRole.USER
                : ConversationRole.AGENT
            }
            content={message.content}
          />
        );
      })}
    </div>
  );
};
